import BaseService from './BaseService';
import apiClient from '../plugins/axios';

/**
 * Collection Service
 */
class CollectionService extends BaseService {
  constructor() {
    super('collection');
  }

  /**
   * List all collections
   * @returns {Promise}
   */
  async getAllCollections() {
    try {
      const response = await apiClient.get('/collection');
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Create a new collection
   * @param {Object} collectionData - Collection data
   * @param {string} collectionData.name - Collection name (required)
   * @param {string} [collectionData.description] - Collection description (optional)
   * @returns {Promise<Object>} API response
   */
  async createCollection(collectionData) {
    try {
      const response = await apiClient.post('/collection', collectionData);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get collection details
   * @param {string} id - Collection ID
   * @returns {Promise}
   */
  async getCollectionById(id) {
    try {
      const response = await apiClient.get(`/collection/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Update collection
   * @param {string} id - Collection ID
   * @param {Object} collectionData - Collection data to update
   * @returns {Promise}
   */
  async updateCollection(id, collectionData) {
    try {
      const response = await apiClient.put(`/collection/${id}`, collectionData);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Delete collection
   * @param {string} id - Collection ID
   * @returns {Promise}
   */
  async deleteCollection(id) {
    try {
      const response = await apiClient.delete(`/collection/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }
}

export default new CollectionService();
